import React from "react";
import { hydrate, render } from "react-dom";
import * as serviceWorker from "./serviceWorker";
//import { initializeGoolgeAnalytics } from "./utils/googleAnalytics";
import { AppThemeProvider } from "./hooks/useAppTheme";
import AppRouter from "./routers/AppRouter";
import PageLayout from "./components/PageLayout";
import ReactGA from "react-ga";
ReactGA.initialize("G-03F25YBFHR");
ReactGA.pageview(window.location.pathname + window.location.search);
//initializeGoolgeAnalytics();

const rootElement = document.getElementById("root");
const app = (
  <AppThemeProvider>
    <React.StrictMode>
      <PageLayout>
        <AppRouter />
      </PageLayout>
    </React.StrictMode>
  </AppThemeProvider>
);

if (rootElement.hasChildNodes()) {
  hydrate(app, rootElement);
} else {
  render(app, rootElement);
}

serviceWorker.unregister();
